import dreamboothIcon from '/assets/images/dreambooth-icon.png'
import klakklikklukIcon from '/assets/klakklikkluk/logo.png'
import bahelaIcon from '/assets/bahela/bahela-pink.webp'

interface LoadingProps {
  text?: string
  state?: 'loading' | 'closing'
}

const Loading = ({ text = 'Loading...', state = 'loading' }: LoadingProps): React.ReactNode => (
  <div className="fixed inset-0 flex justify-center items-center w-full h-screen bg-gray-100/95 backdrop-blur-sm z-50">
    <div className="text-center">
      <div className="relative">
        <img
          src={
            window.location.hostname.includes('klakklikkluk')
              ? klakklikklukIcon
              : window.location.hostname.includes('bahela')
                ? bahelaIcon
                : dreamboothIcon
          }
          alt="Dreambooth"
          className={`w-auto h-24 mb-4 ${state === 'loading' ? 'animate-bounce' : 'animate-pulse'}`}
        />
      </div>
      <p className="text-xl font-medium text-gray-700 animate-pulse">{text}</p>
    </div>
  </div>
)

export default Loading
